var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Route',{staticClass:"HeroScrollDown",attrs:{"to":{ name: _vm.$route.name, hash: _vm.hash }},nativeOn:{"click":function($event){return _vm.scrollToHash.apply(null, arguments)}}},[_c('span',{staticClass:"scroll-label"},[_vm._v(" "+_vm._s(_vm.$t('scroll'))+" ")]),_vm._v(" "),_c('Icon',{attrs:{"name":"scroll-down"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }